module.exports = __webpack_public_path__ + "img/pv1sl.849e5f92.jpg";